import Image from "next/legacy/image"
import Link from "next/link"
import { usePropsObject } from "@/lib/contexts/appContext"
import Block from "@/components/wrappers/block"
import styles from "./categories.module.css"
import cx from "classnames"

export default function Categories({ block }) {
  const { attrs } = block
  const { theme } = usePropsObject()

  if (attrs.cards.length === 0) {
    return null
  }

  const textClass = theme?.bgColor == "black" ? "on-black" : "on-white"

  const Card = ({ item }) => {
    return (
      <li className={styles.card}>
        <Link href={item.url} prefetch={false}>
          <div className="inner-wrapper">
            <div className="text-wrapper">
              <h3 dangerouslySetInnerHTML={{ __html: item.title }}></h3>
            </div>
          </div>
          {item.image && (
            <Image
              src={item.image.url}
              sizes={item.image.sizes}
              layout="fill"
              alt={item.image.alt}
              loading="lazy"
            />
          )}
        </Link>
      </li>
    )
  }

  return (
    <Block block={block} className={cx(styles.wrapper, textClass)}>
      {(attrs.heading || attrs.category.label) && (
        <h2 className="heading">
          {attrs.heading + " "}
          <a className="link-w-hover" href={attrs.category.url}>
            {attrs.category.label}
          </a>
        </h2>
      )}
      {attrs.text && <p className="text">{attrs.text}</p>}
      <ol className="categories">
        {attrs.cards.map((item, index) => {
          return <Card item={item} key={`card-${index}`} />
        })}
      </ol>
    </Block>
  )
}
